export function isNonNullish(x) {
    return x !== null && x !== undefined;
}
export function includes(haystack, needle) {
    const _haystack = haystack;
    return _haystack.includes(needle);
}
//# sourceMappingURL=includes.js.map